import { z } from 'zod';
import type { DepositionalWikiPartsFragment } from '~/apollo/generated/v3/graphql';
import { DepositionalWikiType } from '~/apollo/generated/v3/graphql';
import { ppNumberOrNull, ppStringOrNull } from '~/utils/zod';

export const depositionalWikiTypes: DepositionalWikiType[] = [
  DepositionalWikiType.GrossDepositionalEnvironment,
  DepositionalWikiType.DepositionalEnvironment,
  DepositionalWikiType.DepositionalSubEnvironment,
  DepositionalWikiType.ArchitecturalElement,
  DepositionalWikiType.NotSet,
];

export const depositionalWikiSchema = z.object({
  // Required
  title: z.string().min(2).max(100),
  published: z.boolean(),
  readyForApproval: z.boolean(),

  // Nullable
  geologyType: z.preprocess(ppStringOrNull, z.string().nullable()),
  type: z.preprocess(
    ppStringOrNull,
    z.nativeEnum(DepositionalWikiType).nullable(),
  ),
  value: z.array(z.string()),
  intro: z.preprocess(ppStringOrNull, z.string().nullable()),
  description: z.preprocess(ppStringOrNull, z.string().nullable()),
  diagnostic: z.preprocess(ppStringOrNull, z.string().nullable()),
  reservoir: z.preprocess(ppStringOrNull, z.string().nullable()),
  subsurface: z.preprocess(ppStringOrNull, z.string().nullable()),
  modeling: z.preprocess(ppStringOrNull, z.string().nullable()),
  mafLink: z.preprocess(ppStringOrNull, z.string().nullable()),
  author: z.preprocess(ppStringOrNull, z.string().nullable()),
  modernExample: z.preprocess(ppStringOrNull, z.string().nullable()),
  references: z.preprocess(ppStringOrNull, z.string().nullable()),
  vomExampleId: z.preprocess(ppNumberOrNull, z.number().int().nullable()),
});

export type DepositionalWikiFormValues = {
  title: string;
  intro: string;
  description: string;
  diagnostic: string;
  reservoir: string;
  subsurface: string;
  modeling: string;
  mafLink: string;
  geologyType: string;
  type: DepositionalWikiType;
  value: string[];
  author: string;
  modernExample: string;
  references: string;
  published: boolean;
  readyForApproval: boolean;
  vomExampleId: number | null;
};

export function initialDepositionalWiki(
  wiki?: DepositionalWikiPartsFragment,
): DepositionalWikiFormValues {
  return {
    title: wiki?.title ?? '',
    intro: wiki?.intro ?? '',
    description: wiki?.description ?? '',
    diagnostic: wiki?.diagnostic ?? '',
    reservoir: wiki?.reservoir ?? '',
    subsurface: wiki?.subsurface ?? '',
    modeling: wiki?.modeling ?? '',
    mafLink: wiki?.mafLink ?? '',
    geologyType: wiki?.geologyType ?? '',
    type: wiki?.type ?? depositionalWikiTypes[0],
    value: wiki?.value ?? [],
    author: wiki?.author ?? '',
    modernExample: wiki?.modernExample ?? '',
    references: wiki?.references ?? '',
    published: wiki?.published ?? false,
    readyForApproval: wiki?.readyForApproval ?? false,
    vomExampleId: wiki?.vomExampleId ?? null,
  };
}
